import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  RedirectOrError,
  type RedirectOrErrorProps,
} from '~/components/features/RedirectOrError'
import { exists } from '~/utils'

import { useMainQueryData } from '../hooks/useMainQuery'

export const Restore = () => {
  const { t } = useTranslation()
  const restoringParams = useMainQueryData()
  const getRedirectPath = React.useCallback<
    RedirectOrErrorProps['getRedirectPath']
  >(() => {
    const path = restoringParams?.replace?.path
    const state = restoringParams?.replace?.state
    if (exists(path)) {
      return { success: true, path, state }
    }

    return { success: false, error: t('invalid_url') }
  }, [restoringParams?.replace?.path, restoringParams?.replace?.state, t])

  return <RedirectOrError getRedirectPath={getRedirectPath} />
}
